import { esUnidadContinua, unidadDeCaptura } from '@shared/medidas';

/**
 * Sprint 127 — Lo que el sistema dedujo, dicho en voz alta.
 *
 * Al retirar la pregunta *"¿se vende partido?"* se retira también su respuesta visible, y eso
 * dejaría al operador sin saber en qué quedó su producto. La doctrina del proyecto es que el
 * sistema **explique sus números** en vez de sólo mostrarlos: esta línea dice qué entendió a
 * partir de los tamaños capturados, sin pedir que nadie decida nada.
 */
export function NotaDeTamanos({
  unidad,
  fraccionMinima,
}: {
  unidad: string;
  /** `null` = cualquier cantidad (lo que se pesa o se mide). */
  fraccionMinima: number | null;
}) {
  const texto = (() => {
    if (esUnidadContinua(unidad)) {
      const { nombre } = unidadDeCaptura(unidad);
      return `Puedes poner la cantidad que vendas: 125, 350, 1500… los ${nombre} que sean.`;
    }
    if (fraccionMinima === null || fraccionMinima >= 1) {
      return 'Se vende completo. Si algún día lo partes, agrega el tamaño aquí mismo.';
    }
    return `Se parte: cada venta de ese tamaño descuenta ${fraccionMinima} ${unidad} del inventario.`;
  })();

  return <p className="mt-2 text-xs text-slate-600">{texto}</p>;
}
